import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import userService from '../../services/userService';

function DeleteUserModal({ show, setShow, username, onDeleted }) {
    
    const { t } = useTranslation();

    const handleClose = () => setShow(false);

    const handleSave = () => {
        deleteUser(username)
        setShow(false)
    }


    const deleteUser = async (username) => {
        try {
            const delRes = await userService.deleteUser(username)
            if(delRes.status === 200) {
                onDeleted(null, t("delete_user_modal_delete_successful"))
                return
            } else {
                onDeleted(t("delete_user_modal_delete_failed"), null)
            } 

        } catch (err) {
            onDeleted(t("delete_user_modal_delete_failed"), null)
        }
    }

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("delete_user_modal_title", { USERNAME: username })}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("delete_user_modal_text_content", { USERNAME: username })}</Modal.Body>
                <Modal.Footer className="BREIKKI-delete-user-modal-controls"> 
                        <Button
                            variant="danger"
                            onClick={handleSave}
                            className="BREIKKI-delete-user-modal-controls-delete"
                        >
                            {t("common_delete")}
                        </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DeleteUserModal;